"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Streetview = exports.CSS = void 0;
var tslib_1 = require("tslib");
var mithril_component_1 = require("../../components/mithril.component");
var theme_1 = require("../../components/theme");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
exports.CSS = {
    wrapper: 'c-StreetviewWrapper'
};
var Style = (_a = {},
    _a[exports.CSS.wrapper] = {
        height: '100%',
        width: '100%'
    },
    _a);
(0, theme_1.addStyles)(Style);
var Streetview = /** @class */ (function (_super) {
    tslib_1.__extends(Streetview, _super);
    function Streetview() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Streetview.prototype.onCreate = function (vnode) {
        this.panorama = services_1.Services.Streetview.attach(vnode.dom);
    };
    Object.defineProperty(Streetview.prototype, "nodes", {
        get: function () {
            return (0, mithril_1.m)('div', {
                className: exports.CSS.wrapper
            });
        },
        enumerable: false,
        configurable: true
    });
    return Streetview;
}(mithril_component_1.IMithrilComponent));
exports.Streetview = Streetview;
//# sourceMappingURL=streetview.js.map